import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';

/**
 * Asking for a pipeline change, and deciding on it.
 *
 * Kept out of the Buzz component because the approval is the important part
 * and deserves to be reachable from anywhere — the canvas, a notification, a
 * list of pending changes — not only from the chat window it was asked in.
 */

export async function proposePipelineChange(workspaceId, request) {
  const res = await httpsCallable(functions, 'proposePipelineChange')({ workspaceId, request });
  return res?.data || { success: false, error: 'No response.' };
}

export async function decidePipelineProposal(workspaceId, proposalId, decision) {
  const res = await httpsCallable(functions, 'decidePipelineProposalFn')({ workspaceId, proposalId, decision });
  return res?.data || { success: false, error: 'No response.' };
}

export async function undoPipelineProposal(workspaceId, proposalId) {
  const res = await httpsCallable(functions, 'undoPipelineProposalFn')({ workspaceId, proposalId });
  return res?.data || { success: false, error: 'No response.' };
}
